<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <drdp-title [title]="t('ratingPeriods.title')"></drdp-title>

  <drdp-container>
    <div class="w-full">
      <drdp-search (search)="search($event)" (clear)="onClear()" [searchInput]="searchInput" [textInputPlaceholder]="t('ratingPeriods.searchPlaceholder')"></drdp-search>
      <drdp-add-edit-table
        [dataSource]="dataSource"
        [tableData]="tableData"
        [columns]="tableColumns"
        (toggleSwitchActionItem)="toggleStatus($event)"
        (editActionItem)="openModal($event)"
        [toggleMsg]="t('ratingPeriods.deactivateConfirm')">
      </drdp-add-edit-table>
    </div>
  </drdp-container>

  @if (isAdmin) {
    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [length]="totalData"
      [pageIndex]="pageIndex"
      (page)="getRatingPeriods()">
    </mat-paginator>
  }
</div>
</ng-container>
